/* =========================================================
   BERRYANDBLUSH — mobile-enhancements.js (19.10.2026)
   1. Scroll-Status (Klasse bb-scrolled auf <html>): blendet den
      Widerrufs-Button nach etwas Scrollen aus (siehe CSS).
   2. Warenkorb-Drawer: Versand (5,99 €) und Gesamtsumme anzeigen.
   3. Produktseite: Button "Jetzt bewerten" öffnet das Judge.me-Formular.
   4. (21.10.2026) Desktop: schmale Leiste mit einzeiligem Logo beim Scrollen.
      (22.10.2026) Logo dort als SVG (bb-wordmark.svg) statt PNG: das PNG war
      randlos zugeschnitten und nur 78 px hoch, dadurch wurden obere/untere
      Striche und Querstriche (E, L, B) abgeschnitten bzw. verschluckt.
   Läuft nach global.js (defer, Reihenfolge wie im Dokument).
   ========================================================= */
(function () {
  'use strict';

  var root = document.documentElement;

  /* ---------- 1. Scroll-Status ---------- */
  var ticking = false;
  function updateScrolled() {
    root.classList.toggle('bb-scrolled', (window.pageYOffset || 0) > 200);
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(updateScrolled);
    }
  }, { passive: true });
  updateScrolled();

  /* ---------- 2. Warenkorb-Drawer: Versand + Gesamt ---------- */
  // Versandkosten: pauschal 5,99 €; Geschenkgutschein per Post 4,20 €;
  // digitaler Gutschein versandfrei. Gemischte Warenkörbe (Gutschein per Post
  // + andere Ware) rechnet die Kasse aus.
  var SHIP_STANDARD = 599;
  var SHIP_POST_VOUCHER = 420;

  function fmt(cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: cur });
  }

  function shippingFor(cart) {
    var phys = 0;
    var post = 0;
    (cart.items || []).forEach(function (item) {
      if (item.requires_shipping) {
        phys += 1;
        if (item.handle === 'geschenkgutschein-per-post') post += 1;
      }
    });
    if (phys === 0) return { mode: 'none', cents: 0 };
    if (post === phys) return { mode: 'fixed', cents: SHIP_POST_VOUCHER };
    if (post === 0) return { mode: 'fixed', cents: SHIP_STANDARD };
    return { mode: 'checkout', cents: 0 };
  }

  function renderTotals(cart) {
    var shipEl = document.querySelector('[data-cart-shipping]');
    var totalEl = document.querySelector('[data-cart-total]');
    var totalRow = document.querySelector('[data-cart-total-row]');
    if (!cart || !shipEl || !totalEl) return;
    var s = shippingFor(cart);
    if (s.mode === 'fixed') {
      shipEl.textContent = fmt(s.cents);
    } else if (s.mode === 'none') {
      shipEl.textContent = 'kostenlos';
    } else {
      shipEl.textContent = 'wird an der Kasse berechnet';
    }
    if (totalRow) totalRow.hidden = (s.mode === 'checkout');
    totalEl.textContent = fmt(cart.total_price + s.cents);
  }

  if (window.CartStore) {
    window.CartStore.subscribe(renderTotals);
    if (window.CartStore.state) renderTotals(window.CartStore.state);
  }

  /* ---------- 3. Produktseite: "Jetzt bewerten" -> Judge.me-Formular ---------- */
  var WRITE_SELECTOR = '.jdgm-write-rev-link, [data-testid="write-review-button"]';

  function formIsOpen(box) {
    var form = box.querySelector('.jdgm-form-wrapper');
    return !!(form && form.offsetParent !== null && window.getComputedStyle(form).display !== 'none');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-review-open]') : null;
    if (!btn) return;
    e.preventDefault();
    var box = document.getElementById('bb-review-form');
    if (!box) return;

    box.classList.add('is-open');
    btn.setAttribute('aria-expanded', 'true');

    var tries = 0;
    (function attempt() {
      var writeBtn = box.querySelector(WRITE_SELECTOR);
      if (writeBtn) {
        if (!formIsOpen(box)) writeBtn.click();
        window.setTimeout(function () {
          box.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 150);
        return;
      }
      tries += 1;
      if (tries < 20) {
        window.setTimeout(attempt, 250);
      } else {
        // Widget hat keinen eigenen Button geliefert: komplettes Widget zeigen
        box.classList.add('is-full');
        box.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    })();
  });
})();

/* ---------- 4. Desktop (>= 1024 px): schmale Leiste mit einzeiligem Logo beim Scrollen ----------
   Die Leiste wird aus dem vorhandenen Header gebaut (Menü-Kopie, Icons als Weiterleitung auf die
   Original-Buttons). Sie erscheint, sobald der große Header aus dem Bild gescrollt ist.
   Mobil/Tablet: nichts davon, dort bleibt der normale Header (per CSS sticky). */
(function () {
  'use strict';

  var script = document.currentScript || document.querySelector('script[src*="mobile-enhancements.js"]');
  var wmUrl = script && script.src ? script.src.replace(/mobile-enhancements\.js/, 'bb-wordmark.svg') : '';
  var root = document.documentElement;
  var mq = window.matchMedia('(min-width: 1024px)');
  var slim = null;
  var wrap = null;
  var shown = false;
  var ticking = false;

  function build() {
    var header = document.querySelector('.header');
    var nav = header && header.querySelector('.header__nav');
    var actions = header && header.querySelector('.header__actions');
    if (!header || !nav || !actions || !wmUrl) return;
    wrap = header.closest('.shopify-section') || header;

    slim = document.createElement('div');
    slim.className = 'bb-slim';
    var inner = document.createElement('div');
    inner.className = 'bb-slim__inner';

    var logo = document.createElement('a');
    logo.className = 'bb-slim__logo';
    logo.href = '/';
    logo.setAttribute('aria-label', 'BERRYANDBLUSH');
    var img = new Image();
    img.src = wmUrl;
    img.alt = 'BERRYANDBLUSH';
    // Seitenverhältnis der SVG (viewBox 6700 x 800, inkl. Rand oben/unten)
    img.width = 670;
    img.height = 80;
    img.decoding = 'async';
    logo.appendChild(img);

    var navClone = nav.cloneNode(true);
    navClone.classList.add('bb-slim__nav');
    var navBox = document.createElement('nav');
    navBox.setAttribute('aria-label', 'Hauptmenü kompakt');
    navBox.style.cssText = 'flex:1 1 auto;display:flex;min-width:0;';
    navBox.appendChild(navClone);

    var act = document.createElement('div');
    act.className = 'bb-slim__actions';
    Array.prototype.forEach.call(actions.children, function (el) {
      var c = el.cloneNode(true);
      c.removeAttribute('data-search-open');
      c.removeAttribute('data-cart-open');
      var origCount = el.querySelector('.header__cart-count[data-cart-count-global]');
      Array.prototype.forEach.call(c.querySelectorAll('[data-cart-count-global]'), function (n) {
        n.removeAttribute('data-cart-count-global');
      });
      if (el.tagName === 'BUTTON') {
        c.addEventListener('click', function () { el.click(); });
      }
      var cloneCount = c.querySelector('.header__cart-count');
      if (origCount && cloneCount && window.MutationObserver) {
        var sync = function () {
          cloneCount.textContent = origCount.textContent;
          cloneCount.style.display = origCount.style.display;
        };
        new MutationObserver(sync).observe(origCount, { childList: true, characterData: true, subtree: true, attributes: true });
        sync();
      }
      act.appendChild(c);
    });

    inner.appendChild(logo);
    inner.appendChild(navBox);
    inner.appendChild(act);
    slim.appendChild(inner);
    document.body.appendChild(slim);
  }

  function limit() {
    return Math.max(120, (wrap ? wrap.offsetHeight : 160) - 8);
  }

  function update() {
    ticking = false;
    if (!slim) return;
    var y = window.pageYOffset || 0;
    var on = mq.matches && (shown ? y > limit() - 20 : y > limit());
    if (on !== shown) {
      shown = on;
      root.classList.toggle('bb-slim-on', on);
    }
  }

  build();
  if (!slim) return;
  window.addEventListener('scroll', function () {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  }, { passive: true });
  window.addEventListener('resize', update);
  if (mq.addEventListener) mq.addEventListener('change', update);
  update();
})();
